import { SharedState } from '$utils/sharedState.svelte';
import type { Address } from 'viem';

export interface UserPrimaryGroup {
  mintHandlerAddress?: Address;
  feeCollectionAddress?: Address;
  primaryGroup?: Address;
  erc20WrapperStatic?: Address;
  erc20WrapperDemurrage?: Address;
  picture?: string;
  description?: string;
  name?: string;
  cidV0?: string;
}

class StateUserPrimaryGroup extends SharedState<UserPrimaryGroup> {}

export const stateUserPrimaryGroup = new StateUserPrimaryGroup(null);
